export default function Visible({ when, children }) {
  return when ? children : null;
}
